import { Material } from '../products/product-list/material.model';
import { Package } from './package';

export class PackageProduct {
    orderNumber?: number;
    packageObject?: Package;
    product?: Material;
}
